import React, { Component } from 'react'

import { i18n } from '~/i18n'

import './remove.scss'
import Button from '../button'
import ContentBlock from '../content-block'
import Modal from '../modal'

import classnames from 'classnames'

import type { ReactNode } from 'react'

export type Props = {
  onRemove: () => void
  className?: string
  children?: ReactNode
}
type State = {
  showConfirmation: boolean
}

export default class Remove extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      showConfirmation: false,
    }
  }

  handleShowConfirmationToggle(
    showConfirmation: boolean,
    e?: React.SyntheticEvent<HTMLButtonElement>,
  ) {
    if (e) e.stopPropagation()
    this.setState({
      showConfirmation,
    })
  }

  handleRemove(e: React.SyntheticEvent<HTMLButtonElement>) {
    e.stopPropagation()
    this.handleShowConfirmationToggle(false)
    this.props.onRemove()
  }

  renderConfirmation() {
    if (!this.state.showConfirmation) return
    const onClose = this.handleShowConfirmationToggle.bind(this, false)
    return (
      <Modal
        className="amp-remove-confirmation"
        size="small"
        onClose={onClose}
        title={i18n.t('pages.cart.remove.title')}
        actions={{
          primary: {
            id: 'remove-confirm',
            onClick: this.handleRemove.bind(this),
            className: 'button-confirm',
            text: i18n.t('pages.cart.remove.confirm'),
          },
          secondary: {
            id: 'remove-cancel',
            onClick: onClose,
            className: 'button-cancel',
            text: i18n.t('pages.cart.remove.cancel'),
          },
        }}
      >
        <ContentBlock className="title">
          {i18n.t('pages.cart.remove.heading')}
        </ContentBlock>
        <ContentBlock className="content">
          {i18n.t('pages.cart.remove.content')}
        </ContentBlock>
      </Modal>
    )
  }

  render() {
    const hasChildren = React.Children.count(this.props.children) > 0

    return (
      <div className={classnames('amp-remove', this.props.className)}>
        <Button
          type="icon"
          glyph={hasChildren ? '' : 'xmark'}
          data-testid="remove"
          className="remove"
          onClick={this.handleShowConfirmationToggle.bind(this, true)}
        >
          {this.props.children}
        </Button>
        {this.renderConfirmation()}
      </div>
    )
  }
}
